import { AxiosResponse } from "axios";

import { INoticia, INoticiaPost } from "../Interfaces/model/INoticia";
import { api } from "./api";

const url: string = "noticias-sisep/";

const getNoticias = (): Promise<AxiosResponse<INoticia[]>> => {
  return api.get(url);
};

const getNoticiasToDelete = (): Promise<AxiosResponse<any>> => {
  return api.get(`${url}vinteOuMais`);
};

const getNoticiaSlug = (slug: string): Promise<AxiosResponse<INoticia>> => {
  return api.get(`${url}slug/${slug}`);
};

const getOneOfEach = (): Promise<AxiosResponse<INoticia[]>> => {
  return api.get(url + "cadaCategoria");
};

const postNoticia = (noticia: INoticiaPost): Promise<AxiosResponse> => {
  return api.post(url, noticia);
};

const putNoticia = (id: number, noticia: INoticia): Promise<AxiosResponse> => {
  return api.put(url + id, noticia);
};

const deleteNoticia = (id: number): Promise<AxiosResponse> => {
  return api.delete(url + id);
};

const getNewsPerCategory = (categoryId: number): Promise<AxiosResponse> => {
  return api.get(`categorias/${categoryId}/noticias/delimitada`);
};

const getNewsPerCategoryHome = (categoryId: number): Promise<AxiosResponse> => {
  return api.get(`categorias/${categoryId}/noticias/delimitada-home`);
};

const fivePerCategory = (categoryId: number): Promise<AxiosResponse> => {
  return api.get(`${url}4Porcategoria/${categoryId}`);
};

const getNoticiaByTitle = (title: string): Promise<AxiosResponse> => {
  const encoded = encodeURIComponent(title);
  return api.get(`${url}titulo/${encoded}`);
};

const getLastFourRecent = (): Promise<AxiosResponse> => {
  return api.get(`${url}carrossel`);
};

const noticiaService = {
  getNoticias,
  getNoticiaSlug,
  getNoticiasToDelete,
  postNoticia,
  putNoticia,
  deleteNoticia,
  getOneOfEach,
  getNewsPerCategory,
  fivePerCategory,
  getNoticiaByTitle,
  getNewsPerCategoryHome,
  getLastFourRecent,
};

export default noticiaService;
